module.exports = __webpack_public_path__ + "images/category_lp/brand/new/assessment_achievements/1_99d2202bfcd798fb85ed13399289fe65.png";